export default __webpack_public_path__ + "static/media/Boar.b6074d2f.jpg";